<template>
  <div class="business-circles">
    <ul class="capital">
      <li
        v-for="(item, index) in tableData"
        :key="index"
        :class="{ active: range.includes(index) }"
      >
        <div class="circles-name">
          <div class="name">
            {{ item.name }}
            <img
              class="copy-text"
              src="@/assets/copy-text.png"
              alt="复制"
              v-if="index === 2"
              @click="copyText($event, item.content)"
            />
          </div>
          <div class="value">
            {{ item.content }}
          </div>
        </div>
      </li>
    </ul>
    <!-- <ul class="demeanor">
      <li class="circles-name">
        <div class="name">企业风采</div>
      </li>
      <li
        class="demeanor-list"
        v-if="
          (corporate.pictureFiles && corporate.pictureFiles.length > 0) ||
            (corporate.videoFiles && corporate.videoFiles.length > 0)
        "
      >
        <div>
          <img
            @click="bigUrl(item.ossUrl)"
            v-for="(item, index) in corporate.pictureFiles"
            :key="index"
            :src="item.ossUrl"
            alt=""
          />
        </div>
        <div v-if="addressUrl">
          <video
            width="200px"
            height="145px"
            controls
            class="video-play"
            x5-video-player-type="h5"
            v-for="(i, x) in corporate.videoFiles"
            :key="x"
          >
            <source :src="i.ossUrl" type="video/mp4" />
            浏览器不支持 video 标签，建议升级浏览器。
          </video>
        </div>
      </li>
      <li v-else>
        <van-empty
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无数据"
        />
      </li>
    </ul> -->
    <div class="big-img" v-if="bigImg" @click="bigImg = false">
      <img :src="bigPicture" alt="" />
    </div>
  </div>
</template>

<script>
import { getLocalStorage, getToken } from '@utils'
import { getEntDetail } from '@api/businessInformation/index'
import { getAddress } from '@api/lishui/live'
import Clipboard from 'clipboard'
import { Toast } from 'vant'

export default {
  props: ['corporate'],
  data() {
    return {
      tableData: [
        { name: '联系电话', content: 'entTel' },
        { name: '公司邮箱', content: 'entMail' },
        { name: '网址', content: 'entWeb' },
        { name: '所在区域', content: 'address' },
        { name: '经办人姓名', content: 'jbrName' },
        { name: '经办人电话', content: 'jbrTel' },
        { name: '财务姓名', content: 'financialName' },
        { name: '财务电话', content: 'financialTel' },
        { name: '人事姓名', content: 'personnelName' },
        { name: '人事电话', content: 'personnelTel' },
        { name: '公司简介', content: 'brief' }
      ],
      range: [10],
      bigImg: false,
      bigPicture: '',
      files: [],
      addressUrl: ''
    }
  },
  created() { },
  mounted() {
    if (getToken()) {
      this.loginTokens()
    }
  },
  methods: {
    loginTokens() {
      getAddress().then((res) => {
        this.addressUrl = res.data.data
        let list = this.corporate.entData
        if (list) {
          // 视频
          /*  this.corporate.videos.map((value) => {
            value.ossUrl =
              this.addressUrl +
              process.env.VUE_APP_REQUEST_PREFIX3 +
              '/api/file/download?ossUrl=' +
              value.ossUrl +
              '&fileName=' +
              value.moduleKey
          }) */
          // 数据
          this.tableData.map((value) => {
            Object.keys(list).find((val) => {
              if (value.content === val) {
                value.content = list[val] ? list[val] : '-'
              }
            })
          })

          this.tableData[3].content = list.province + list.city + list.county
        }
      })
    },

    // 图片放大
    bigUrl(e) {
      this.bigImg = true
      this.bigPicture = e
    },
    copyText(e, text) {
      const clipboard = new Clipboard(e.target, { text: () => text })
      clipboard.on('success', e => {
        Toast('复制成功')
      })
      clipboard.onClick(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.business-circles {
  padding: 18px;
  position: relative;
  .circles-name {
    margin-bottom: 10px;
    .name {
      color: #999;
      font-size: 12px;
      margin-bottom: 6px;
      .copy-text {
        width: 15px;
        vertical-align: middle;
      }
    }
    .value {
      display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
      -webkit-line-clamp: 2; //规定行数;
      word-wrap: break-word;
    }
    div {
      font-weight: 500;
      color: rgba(5, 27, 59, 100);
      font-size: 14px;
      // width: 166px;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      // white-space: nowrap;
    }
  }
  .capital {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    li {
      width: 49%;
      height: 44px;
      margin-bottom: 24px;
      padding-right: 2px;
      box-sizing: border-box;
    }
    li:nth-child(even) {
      padding-left: 10px;
      border-left: 1px solid rgba(226, 226, 226, 1);
    }
    .active {
      width: 100%;
      height: auto;
      padding-left: 0 !important;
      border-left: none !important;
      .circles-name {
        div {
          width: auto;
          white-space: pre-wrap;
        }
      }
    }
  }
  .demeanor {
    .demeanor-list {
      display: flex;
      overflow: hidden;
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;
      display: -webkit-box;
      white-space: nowrap;
      img {
        width: 200px;
        height: 130px;
        margin-right: 20px;
      }
      .video-play {
        background-color: #000;
        margin-right: 20px;
      }
    }
  }
  .big-img {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background-color: #000;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      height: 280px;
      margin: auto 0;
    }
  }
  /deep/.custom-image .van-empty__image {
    padding: 0 !important;
    width: 40px !important;
    height: 40px !important;
  }
}
</style>
